import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        step: null,
        tabs: [],
    },
    getters: {
        step: state => state.step,
        tabs: state => state.tabs,
    },
    mutations: {
        step(state, step) {
            state.step = step;
        },

        tabs(state, tabs) {
            state.tabs = tabs;
        }
    },
    actions: {
        ...useActions(),
    },
}
